export function evaluateScript(textContent) {
    const parsedJavascript = document.createElement("script");
    parsedJavascript.textContent = textContent;
    document.head.appendChild(parsedJavascript);
    setTimeout(() => {
        parsedJavascript.remove();
    }, 1);
}
